export default "__VITE_ASSET__DeuaYbVs__"